import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui";
import { ReadMore } from "components/atoms";

const PersonalDisclosures = ({ disclosuresInfo }) => {
  const disclosureItems = [
    {
      title: "Smoking or vaping",
      isRequestKey: "is_smoking_request",
      descriptionKey: "smoke_description",
    },
    {
      title: "Tattoos",
      isRequestKey: "is_tattoos_request",
      descriptionKey: "tattoos_description",
    },
    {
      title: "Chronic illness or disabilities",
      isRequestKey: "is_chronic_illness_or_disabilities_request",
      descriptionKey: "chronic_illness_or_disabilities_description",
    },
    {
      title: "Past surgeries",
      isRequestKey: "is_past_surgies_request",
      descriptionKey: "past_surgies_description",
    },
    {
      title: "Major debt",
      isRequestKey: "is_major_debt_request",
      descriptionKey: "major_debt_description",
    },
    {
      title: "Other",
      isRequestKey: "is_other_request",
      descriptionKey: "other_request_description",
    },
  ];

  return (
    <div>
      <Card className="min-w-full">
        <CardHeader>
          <CardTitle>Personal Disclosures</CardTitle>
        </CardHeader>
        <CardContent className="p-2">
          <div className="flex flex-col gap-3">
            {disclosureItems.map((item, index) => (
              <div
                key={index}
                className="flex items-center justify-between flex-wrap border border-border rounded-xl gap-2 px-4 py-4 bg-secondary-clarity w-full"
              >
                <div className="flex items-center gap-3.5 w-full">
                  <div className="flex flex-col w-full">
                    <div className="text-base font-medium text-mono text-start">
                      {item.title}
                    </div>

                    {/* Visible on request */}
                    <div className="flex justify-between gap-2 w-full">
                      <p className="text-sm text-secondary-foreground">
                        Visible on request
                      </p>
                      <p className="text-sm text-[#2d2a33] font-semibold">
                        {disclosuresInfo?.[item.isRequestKey] ? "Yes" : "No"}
                      </p>
                    </div>

                    {/* Description */}
                    <div className="flex justify-between gap-12 w-full">
                      <p className="text-sm text-secondary-foreground">
                        {item.isRequestKey === "is_past_surgies_request" ||
                        item.isRequestKey === "is_major_debt_request"
                          ? "Private by default — only shared if requested by a match"
                          : "Description"}
                      </p>
                      <p className="text-sm text-[#2d2a33] font-semibold break-all text-left">
                        <ReadMore
                          comment={
                            disclosuresInfo?.[item.descriptionKey] ?? "N/A"
                          }
                          maxChar={20}
                        />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PersonalDisclosures;
